import styled from 'styled-components';
import { COLOR, FONT_SIZE, SPACING } from '../../../../packages/constants';
import { ToggleAccountRow } from '../account-row/account-row';

export interface AccountCellProps {
    canBeToggled?: boolean; // can toggle visibility
    hasBorderRight?: boolean;
    hasTextAlignedLeft?: boolean;
    hasNoPadding?: boolean;
    indent?: boolean;
    isBudget?: boolean; // yellow cell isBudget
    isEditable?: boolean; // can be edited
    isGroup?: boolean; // is a group cell type
    isHeader?: boolean; // header styles
    isLocked?: boolean; // show lock symbol
    isNumber?: boolean; // text-aligned right
    isTotal?: boolean; // grey cell
    minWidth?: number;
    isDisplayed?: boolean;
}

export const AccountCell = styled.div<AccountCellProps>`
    box-sizing: border-box;
    border-top: 1px solid ${(props) => (props.isGroup ? COLOR.DATAGRID.DATAGRID_DIVIDER_LINE : COLOR.MAIN.FORM_FIELD)};
    border-left: 1px solid ${COLOR.MAIN.FORM_FIELD};
    background-color: ${(props) =>
        props.isHeader
            ? COLOR.PRIMARY.WHITE
            : props.isBudget
            ? COLOR.DATAGRID.DATAGRID_BUDGET_BG
            : props.isTotal
            ? COLOR.DATAGRID.DATAGRID_TOTAL_BG
            : COLOR.PRIMARY.WHITE};
    display: ${(props) => ((props.canBeToggled && props.isDisplayed) || !props.canBeToggled ? 'inline-flex' : 'none')};
    padding: ${(props) =>
        props.isGroup && !props.isNumber && !props.canBeToggled
            ? '0'
            : props.indent
            ? `${SPACING.SMALL} ${SPACING.SMALL} ${SPACING.SMALL} ${SPACING.XX_LARGE}`
            : props.hasNoPadding
            ? '0'
            : SPACING.SMALL};
    font-size: ${FONT_SIZE.X_SMALL};
    font-weight: ${(props) => (props.isHeader ? '700' : '400')};
    justify-content: ${(props) =>
        props.hasTextAlignedLeft
            ? 'flex-start'
            : props.isHeader && !props.isTotal
            ? 'center'
            : props.isNumber
            ? 'flex-end'
            : props.isGroup
            ? 'flex-end'
            : props.isTotal && props.isHeader
            ? 'space-between'
            : 'flex-start'};
    line-height: 15px;
    width: 100%;
    min-width: ${(props) => (props.minWidth ? `${props.minWidth}px` : props.isTotal ? '100%' : '95px')};
    position: relative;
    color: ${COLOR.DATAGRID.DATAGRID_TEXT};

    &:last-child {
        border-right: 1px solid ${COLOR.MAIN.FORM_FIELD};
    }

    ${ToggleAccountRow} {
        padding: ${SPACING.SMALL};
    }

    input[type='checkbox'] {
        margin: 0;
        margin-top: -1px;
        position: relative;
        top: 2px;
        height: 13px;
        width: 13px;
    }

    ${({ isLocked }) =>
        isLocked &&
        `
        padding-left ${SPACING.LARGE};
        
        &::before {
            position: absolute;
            font-family: 'FontAwesome', sans-serif;
            bottom: ${SPACING.X_SMALL};
            left: ${SPACING.X_SMALL};
            content: '\f023';
            color: ${COLOR.MAIN.DARK_GREY};
            opacity: 0.3;
        }`}
`;

export const TruncateText = styled.div`
    display: block;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    width: 269px;
    text-align: left;
`;
